import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  getUserNotifications,
  markNotificationRead,
} from '../../modules/notification';
import NotificationsDrawer from './NotificationsDrawer';
import ForceRefreshModal from '../elements/ForceRefreshModel';

const UserNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [totalUnRead, setTotalUnRead] = useState(0);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [refreshNotification, setRefreshNotification] = useState(null);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response = await getUserNotifications(0, 5);
      setNotifications(response.notifications);
      setTotalUnRead(response.total_unread);
      const refreshNotif = response.notifications.find(
        (n) => (n.type === 'refresh_required' || n.type === 'system-update') && n.status === 'unread',
      );
      setRefreshNotification(refreshNotif || null);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 300000);
    return () => clearInterval(interval);
  }, []);

  const handleRefreshConfirm = async () => {
    const notif = refreshNotification;
    setRefreshNotification(null);
    if (notif) {
      await markNotificationRead(notif.id);
    }
    window.location.reload();
  };
  const handleCancelConfirm = async () => {
    setRefreshNotification(null);
    if (refreshNotification) {
      await markNotificationRead(refreshNotification.id);
    }
  };
  return (
    <>
      <IconButton
        onClick={() => setDrawerOpen(true)}
        aria-label="Notifications"
        disableRipple>
        <Badge badgeContent={totalUnRead} color="error">
          <NotificationsIcon
            sx={{ color: drawerOpen ? 'var(--primary-color)' : 'action.active' }}
          />
        </Badge>
      </IconButton>

      <NotificationsDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        notifications={notifications}
        totalUnRead={totalUnRead}
        loading={loading}
        fetchNotifications={fetchNotifications}
      />

      {refreshNotification && (
        <ForceRefreshModal
          open={Boolean(refreshNotification)}
          title={refreshNotification?.title}
          message={refreshNotification?.body}
          onConfirm={handleRefreshConfirm}
          onClose={handleCancelConfirm}
          hideCancel={refreshNotification?.type === 'system-update'}
        />
      )}
    </>
  );
};

export default UserNotifications;
